var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66421 13.3286C6.66415 13.4525 6.6986 13.5739 6.7637 13.6792C6.82879 13.7846 6.92196 13.8697 7.03274 13.9251L8.3656 14.5915C8.46723 14.6423 8.58015 14.6662 8.69365 14.6611C8.80714 14.656 8.91744 14.6219 9.01406 14.5621C9.11068 14.5024 9.19042 14.4189 9.2457 14.3196C9.30099 14.2204 9.32998 14.1086 9.32993 13.995V9.33003C9.33008 8.99973 9.45286 8.68126 9.67447 8.43635L14.4881 3.11224C14.5744 3.01664 14.6311 2.8981 14.6514 2.77095C14.6718 2.64379 14.6548 2.51347 14.6027 2.39574C14.5505 2.27801 14.4653 2.17792 14.3575 2.10756C14.2496 2.03721 14.1237 1.9996 13.9949 1.9993H1.9992C1.87031 1.99934 1.74421 2.03676 1.63616 2.10702C1.52811 2.17727 1.44275 2.27735 1.39042 2.39513C1.33809 2.51291 1.32103 2.64334 1.34131 2.77062C1.3616 2.89789 1.41835 3.01656 1.50471 3.11224L6.31966 8.43635C6.54127 8.68126 6.66406 8.99973 6.66421 9.33003V13.3286Z",
    stroke: "#364153",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9943,
    height: 15.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.f35df9edb58b80e4bdadf384f7bb8e41.svg";
export { ForwardRef as ReactComponent };